module.exports = __webpack_public_path__ + "img/logo.74835769.png";